import { ErpTrackingPayload } from '../models/erp-tracking.model';

export class ErpTrackingItemLoad {
  public static readonly type = '[ERP Tracking] Load';
  constructor(public payload: ErpTrackingPayload) {}
}

export class ErpTrackingInitialState {
  public static readonly type = '[ERP Tracking] Set initial state';
}
